export const DriverReviewLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
};
